module.exports = __webpack_public_path__ + "static/media/Pin-Light-Ocorrencia.6f0e7ac2.svg";